import { skipToken } from '@reduxjs/toolkit/query';
import { useGetActiveMissionQuery, useOnMissionV3SubscriptionQuery } from 'services/missionV3';

interface Props {
    vin?: string;
}

const useGetMissionData = ({ vin }: Props) => {
    const arg = vin || skipToken;

    // Keeps the AppSync subscription for this vin alive. Its own cached `MissionV2` is deliberately
    // not read — the live data reaches us through the cross-patch into `getActiveMission`.
    useOnMissionV3SubscriptionQuery(arg);

    // `currentData` (not `data`) is intentional: `data` returns the last known good value across
    // hook args, which would silently show a previous VIN's mission on failure. `currentData` is
    // scoped to the current arg, so a failed/in-flight request yields `undefined` instead of stale data.
    const { currentData, isFetching, isError, error } = useGetActiveMissionQuery(arg);

    return {
        data: currentData,
        isFetching: isFetching && currentData === undefined,
        isError,
        error,
    };
};

export default useGetMissionData;
